<div class="walkthrough-toggle dashboard__help" (click)="toggleWalkthrough()">
  <span class="walkthrough-toggle__text">Support</span>
  <mat-icon class="walkthrough-toggle__icon"> help_outline </mat-icon>
</div>
